import { auth, identityAuth, isIdentityIntegrationEnabled } from '../firebase';

/**
 * ID token for Fury Registration HTTP API (must be issued by Fury Identity).
 * @returns {Promise<{ ok: true, idToken: string } | { ok: false, error: string }>}
 */
export async function getFuryRegistrationIdToken() {
  if (isIdentityIntegrationEnabled() && identityAuth) {
    const u = identityAuth.currentUser;
    if (!u) {
      return {
        ok: false,
        error:
          'Fury Identity session missing. Sign out and sign in again so Identity stays linked (needed for Registration API).',
      };
    }
    try {
      // Force refresh so Fury verifyIdToken sees a valid JWT and latest custom claims (e.g. admin).
      const idToken = await u.getIdToken(true);
      return { ok: true, idToken };
    } catch (e) {
      return { ok: false, error: e.message || 'Could not read Identity token.' };
    }
  }
  const u = auth.currentUser;
  if (!u) {
    return { ok: false, error: 'You must be signed in.' };
  }
  try {
    const idToken = await u.getIdToken(true);
    return { ok: true, idToken };
  } catch (e) {
    return { ok: false, error: e.message || 'Could not read ID token.' };
  }
}
